import { UIManager } from '@/Core/Managers/UI/UIManager'
import type { IDrawerConfig } from '@/Core/Contracts/UI/Drawer'
import { action, makeObservable, observable } from 'mobx'
import React from 'react'

interface DrawerStoreConfig extends IDrawerConfig {
    isOpen?: boolean
}

export class DrawerStore extends UIManager {
    extra: React.ReactNode[] = []
    title: React.ReactNode | false = false
    isOpen: boolean = false

    constructor({ title, extra, isOpen, open, ...props }: DrawerStoreConfig = {}) {
        super(props)

        if (title !== undefined) this.title = title

        if (Array.isArray(extra)) {
            this.extra = extra
        }

        // Підтримка як isOpen, так і open (з AntdDrawerProps)
        if (typeof isOpen === 'boolean') {
            this.isOpen = isOpen
        } else if (typeof open === 'boolean') {
            this.isOpen = open
        }

        // ВАЖЛИВО: додаємо всі властивості в props щоб Antd Drawer отримав їх
        this.props['open'] = this.isOpen
        this.props['title'] = this.title
        this.props['extra'] = this.extra

        makeObservable(this, {
            isOpen: observable,
            title: observable,
            extra: observable,
            setIsOpen: action,
            setTitle: action,
        })
    }

    setTitle(title: React.ReactNode | false): void {
        this.title = title
        // ВАЖЛИВО: синхронізуємо з props
        this.props['title'] = title
    }

    setIsOpen(isOpen: boolean): void {
        if (typeof isOpen === 'boolean') {
            this.isOpen = isOpen
            // ВАЖЛИВО: синхронізуємо з props
            this.props['open'] = isOpen
        }
    }
}
